import React, { useState, useContext } from 'react';
import { Authentication } from '../../App'
import axios from "axios";
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
// import Avatar from '@mui/material/Avatar';
// import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import LogoutIcon from '@mui/icons-material/Logout';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Divider from '@mui/material/Divider';
import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import { useNavigate  } from 'react-router-dom';

import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ContentPasteGoIcon from '@mui/icons-material/ContentPasteGo';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';

import Link from '@mui/material/Link';
// import { color } from '@mui/system';
import { Typography } from '@mui/material';

// import styled from 'styled-components';



// const MenuLi = styled.li`
//     display: inline-block;
    
// `;

function HeaderComponents(){
  const authentication = useContext(Authentication);
  const [user, setuser] = useState();

  const handlelogout = () =>{

  }

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl2, setAnchorEl2] = useState(null);
  const open2 = Boolean(anchorEl2);
  const handleClick2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };
  const handleClose2 = () => {
    setAnchorEl2(null);
  };
  
  const navigate = useNavigate();
  const [open3, setOpen3] = useState(false);
  const anchorRef = React.useRef(null);
  
  const handleToggle = () => {
    setOpen3((prevOpen) => !prevOpen);
  };
  
  const handleClose3 = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
  
    setOpen3(false);
  };
  
  // function handleListKeyDown(event) {
  //   console.log(event.key, "event.key");
  //   if (event.key === 'Tab') {
  //     event.preventDefault();
  //     setOpen3(false);
  //   } else if (event.key === 'Escape') {
  //     setOpen3(false);
  //   }
  // }
  
  const prevOpen = React.useRef(open3);
  React.useEffect(() => {
    if (prevOpen.current === true && open3 === false) {
      anchorRef.current.focus();
    }
  
    prevOpen.current = open3;
  }, [open3]);  

  // const [state, setState] = useState('');

  // const handleChange = (event) => {
  //   setState(event.target.value);
  // };


  // 社内データ系
  // React.useEffect(() => {
  //   let url = "http://localhost:5000/v1/recruiting/getBirthplace";
  //   axios.get(url).then((response) => {
  //     console.log(response)
  //     setshussin(response.data);
  //   });

    
  // }, []);
  // React.useEffect(() => {
  //   let s_data = "http://localhost:5000/v1/recruiting/getShanaiData";
  //   axios.get(s_data).then((abc) => {
  //     setShanaiData(JSON.parse(JSON.stringify(abc.data[0])));
  //     setEditShanaiData(JSON.parse(JSON.stringify(abc.data[0])));
  //   });
    
  // }, []);
  

  React.useEffect(() => {
    // let url = `http://localhost:5000/v1/users/detail`;
    let url = process.env.REACT_APP_API_BASE_URL + `/v1/users/detail`;

    axios.get(url, { headers: { 'Authorization': 'Bearer ' + authentication.getAccessToken(), 'Content-type': 'application/json; charset=UTF-8' } }).then((response) => {
      setuser(response.data)
    });

  }, []);
  if (!user) return null;



  return (
    <header className="App">
      <AppBar position="static" style={{backgroundColor:'#4682b4',position: 'fixed',right: 0,left: 0,zIndex: 1030}}>
        <Toolbar variant="dense" style={{minHeight: '50px'}}>
          <Link href="/" underline="none">
            <img className='logo' src='https://www.homestation.jp/manage/assets/img/common/homestation.svg' alt="logo"/>
          </Link>

          <Box className="userbox" sx={{ flexGrow: 0, marginLeft: 'auto', display: 'inline-flex'}}>
            <div>
              <IconButton
                ref={anchorRef}
                id="composition-button"
                aria-controls={open3 ? 'composition-menu' : undefined}
                aria-expanded={open3 ? 'true' : undefined}
                aria-haspopup="true"
                onClick={handleToggle}
                style={{color:"#316689",marginRight:0}}
              >
                {/* <ArrowDropDownIcon style={{fontSize: 30}} /> */}
                <Typography className="user" sx={{color: 'white'}}>
                  ログイン中：　{user.Tenpo_Name}　{user.user_name_all}
                </Typography>
              </IconButton>
              <Popper
                open={open3}
                anchorEl={anchorRef.current}
                role={undefined}
                placement="bottom-start"
                transition
                disablePortal
              >
                {({ TransitionProps, placement }) => (
                  <Grow
                    {...TransitionProps}
                    style={{
                      transformOrigin:
                        placement === 'bottom-start' ? 'left top' : 'left bottom',
                    }}
                  >
                    <Paper>
                      <ClickAwayListener onClickAway={handleClose3}>
                        <MenuList
                          autoFocusItem={open3}
                          id="composition-menu"
                          aria-labelledby="composition-button"
                          // onKeyDown={handleListKeyDown}
                        >
                          <MenuItem onClick={() => {navigate('/StampCard'); setOpen3(false)}}><TaskAltIcon sx={{ fontSize: 30, color: '#316689', mr: 1 }} />スタンプカード</MenuItem>
                          <Divider />
                          <MenuItem onClick={() => {navigate('/passwordHenkou'); setOpen3(false)}}><ContentPasteGoIcon sx={{ fontSize: 30, color: '#316689', mr: 1 }} />研修申込</MenuItem>
                          <Divider />
                          <MenuItem onClick={() => {navigate('/logout'); setOpen3(false)}}><HeadsetMicIcon sx={{ fontSize: 30, color: '#316689', mr: 1 }} />通信教育申込</MenuItem>
                          <Divider />
                          <MenuItem onClick={() => {navigate('/StampPut'); setOpen3(false)}}><AddCircleOutlineIcon sx={{ fontSize: 30, color: '#316689', mr: 1 }} />スタンプ付与</MenuItem>
                          <Divider />
                          <MenuItem onClick={() => {navigate('/logout'); setOpen3(false)}}><AssignmentTurnedInIcon sx={{ fontSize: 30, color: '#316689', mr: 1 }} />登録</MenuItem>
                        </MenuList>
                      </ClickAwayListener>
                    </Paper>
                  </Grow>
                )}
              </Popper>
            </div>
            <Tooltip title="ログアウトする">
              <IconButton onClick={handlelogout} sx={{ p: 0 ,mr:0}}>
                {/* <Avatar alt="Remy Sharp" src="/static/images/avatar/2.jpg" /> */}
                <LogoutIcon className='usericon' size='large'/>
              </IconButton>
            </Tooltip>
          </Box>
          
          <Box className="sp_btns" sx={{ marginLeft:'auto', }}>
            <div className='user_btn'>
              <IconButton
                size="large"
                id="demo-positioned-button2"
                aria-controls={open2 ? 'demo-positioned-menu2' : undefined}
                aria-haspopup="true"
                aria-expanded={open2 ? 'true' : undefined}
                onClick={handleClick2}
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <AccountCircleIcon className='user_icon'/>
              </IconButton>
              <Menu
                id="demo-positioned-menu2"
                aria-labelledby="demo-positioned-button2"
                anchorEl={anchorEl2}
                open={open2}
                onClose={handleClose2}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                
                <MenuItem sx={{fontSize:14}} onClick={handleClose2}>ログイン中<br/>{user.Tenpo_Name}　{user.user_name_all}</MenuItem>
                <Divider />
                <Link href="#" color="inherit" underline="none">
                  <MenuItem sx={{fontSize:14}} onClick={handleClose2}>ログアウト</MenuItem>
                </Link>
              </Menu>
            </div>
            <div className='hamburger'>
              <IconButton
                size="large"
                id="demo-positioned-button"
                aria-controls={open ? 'demo-positioned-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                aria-label="menu"
                sx={{ mr: 2 }}
              >
                <MenuIcon className='hamburger_icon'/>
              </IconButton>
              <Menu
                id="demo-positioned-menu"
                aria-labelledby="demo-positioned-button"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'left',
                }}
              >
                <Link href="/" color="inherit" underline="none">
                  <MenuItem sx={{fontSize:14}} onClick={handleClose}>総務データ</MenuItem>
                </Link>
                <Link href="/RecruitEarnings" color="inherit" underline="none">
                  <MenuItem sx={{fontSize:14}} onClick={handleClose}>売上データ</MenuItem>
                </Link>
                <Link href="/RecruitLine" color="inherit" underline="none">
                  <MenuItem sx={{fontSize:14}} onClick={handleClose}>LINE</MenuItem>
                </Link>
                <Link href="/RecruitNews" color="inherit" underline="none">
                  <MenuItem sx={{fontSize:14}} onClick={handleClose}>NEWS</MenuItem>
                </Link>
                <Link href="/PersonalGoals" color="inherit" underline="none">
                  <MenuItem sx={{fontSize:14}} onClick={handleClose}>個人目標</MenuItem>
                </Link>
                <Link href="/Introduction" color="inherit" underline="none">
                  <MenuItem sx={{fontSize:14}} onClick={handleClose}>自己紹介</MenuItem>
                </Link>
                {/* <Link href="#" color="inherit" underline="none">
                  <MenuItem onClick={handleClose}>ログアウト</MenuItem>
                </Link> */}
              </Menu>
            </div>
          </Box>


        </Toolbar>
    </AppBar>
      {/* <Route path='/Recruit' component={Recruit} /> */}
      <style jsx="true">{
        `
        .hamburger{
          display:none;
        }
        .user_btn{
          display:none;
        }
        .sp_btns{
          display:none;
        }
        @media screen and (max-width: 768px) {
          .sp_btns{
            display:flex;
          }
          .css-1qzqbde-MuiButtonBase-root-MuiIconButton-root{
            margin-right:0;
          }
          .css-kk1bwy-MuiButtonBase-root-MuiMenuItem-root{
            font-size:14px;
          }
          .hamburger{
            display:block;
          }
          .user_btn{
            display:block;
          }
          .userbox{
            display:none;
          }
        }
        .hamburger_icon,.user_icon{
          color:#fff;
        }
        .css-19r6kue-MuiContainer-root {
          max-width: 100%;
         
        }
        .css-hip9hq-MuiPaper-root-MuiAppBar-root{
          background-color:#4682b4;
          position: fixed;
          right: 0;
          left: 0;
          z-index: 1030;
        }
        .css-r6ewbb-MuiToolbar-root {
          min-height: 50px;
        }
        .logo{
          width: 200px;
          height: 35px;
        }
        .user{
          padding-right:20px;
          font-size:14px;
        }
        .usericon{
          width: 25px;
          height: 25px;
          color:#fff;
        }
        `
      }
      </style>
    </header>
  );
    // };
};

export default HeaderComponents;
